import { jsx } from "react/jsx-runtime";
import Typography$1 from "@mui/material/Typography";
import { FontWeights } from "../constants.js";
function Typography({
  variant = "Body",
  fontWeight,
  children,
  ...props
}) {
  const weightType = () => {
    switch (fontWeight) {
      case "light":
        return FontWeights.LIGHT;
      case "normal":
        return FontWeights.NORMAL;
      case "medium":
        return FontWeights.MEDIUM;
      case "semibold":
        return FontWeights.SEMI;
      case "bold":
        return FontWeights.BOLD;
      case "extrabold":
        return FontWeights.EXTRABOLD;
      case "heavy":
        return FontWeights.HEAVY;
      default: {
        if (typeof fontWeight === "number") {
          return fontWeight;
        }
        return FontWeights.NORMAL;
      }
    }
  };
  return /* @__PURE__ */ jsx(Typography$1, { variant, sx: {
    ...props.sx,
    fontWeight: fontWeight ? weightType() : void 0
  }, ...props, children });
}
export {
  FontWeights,
  Typography
};
//# sourceMappingURL=index.js.map
